import { render, staticRenderFns } from "./FormStream.vue?vue&type=template&id=54cd52b8&"
import script from "./FormStream.vue?vue&type=script&lang=js&"
export * from "./FormStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54cd52b8')) {
      api.createRecord('54cd52b8', component.options)
    } else {
      api.reload('54cd52b8', component.options)
    }
    module.hot.accept("./FormStream.vue?vue&type=template&id=54cd52b8&", function () {
      api.rerender('54cd52b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/stream/form/FormStream.vue"
export default component.exports